



























































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '../../util/constants';
import { ApiRequest } from '../../types/request';
import DataTable from '../../components/DataTable.vue';
import { CommonUtils } from '../../util/commonUtils';
import { DateUtils } from '../../util/dateUtils';
import { DriverProfile } from '@/types/response';
import ViewDocumentModal from './ViewDocumentModal.vue';

// tslint:disable-next-line: no-var-requires
const DriverDocumentTable = require('../../datatable/DriverDocumentsTable');

@Component({
    components: {
        DataTable,
        ViewDocumentModal,
    },
    methods: {
        formatDate(date: any) {
            return DateUtils.formatDate(date, DateUtils.FORMAT_DATETIME_AM_PM);
        },
    },
})
export default class ViewDriverDetailModal extends Vue {
    private show = false;
    private showDocumentModal = false;
    private driver: DriverProfile | undefined;
    private driverDocumentDataSource = DriverDocumentTable;
    private resourceId: string = '';
    private mounted() {
        this.getDriver();
    }
    private async getDriver() {
        const iHttpService = ObjectFactory.getHttpService();
        const driverId = this.$route.params.id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/${driverId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<DriverProfile>(apiRequest);
        if (response.success && response.data) {
            this.driver = response.data;
            if (!this.driver.isCertified) {
                this.driver.isCertified = '-' as any;
            }
            if (response.data.documents) {
                response.data.documents.forEach((element) => {
                    if (!element.description) {
                        element.description = '-' as any;
                    }
                    element.status = element.rejected ? 'Rejected' : element.verified ? 'Verified' : 'Not Verified';
                    element.expirationDate = element.expirationDate ? DateUtils.formatDate(element.expirationDate, 'MM/DD/YYYY') : '-' as any;
                });
                this.driverDocumentDataSource.data = response.data.documents;
                this.driverDocumentDataSource.totalCount = response.data.documents.length;
            }
            this.show = true;
        } else {
            CommonUtils.showError(response);
        }
    }
    private viewDocument(document?: any) {
        this.resourceId = document.resourceId;
        this.showDocumentModal = true;
    }
    private close() {
        this.$router.back();
    }
}
